import { DatasourceOfflineDao } from './datasource-offline.dao';
import { PlatformService } from '../../platform/platform.service';
import { DatasourcesOfflineAndroidDao } from './datasource-offline-android.dao';
import { DatasourcesOfflineWebDao } from './datasource-offline-web.dao';

const DatasourceOfflineDaoFactory = (platformService: PlatformService) => platformService.isAndroidApp() ? 
    new DatasourcesOfflineAndroidDao() : new DatasourcesOfflineWebDao();

export const DatasourceOfflineDaoProvider = { 
    provide: DatasourceOfflineDao,
    useFactory: DatasourceOfflineDaoFactory,
    deps: [PlatformService]
};